<template>
    <div>
        <p class="mb-0">{{ field.listTitle }}</p>
        <div v-if="edit" class="p-2 border-light">
            <div v-if="field.list.length" v-for="(li, index) in field.list">
                <em
                    >{{ index + 1 }}. <span class="list-props" v-for="pr in li">{{ pr }}</span></em
                >
            </div>
            <div v-for="f in field.listFields">
                <multi-field
                    v-if="f.enabled"
                    :patient-data="patientData"
                    :edit="edit"
                    :field="f"
                    @set-value="f.value = $event"
                ></multi-field>
            </div>
            <a
                class="text-primary font-weight-bold text-uppercase btn btn-sm btn-outline-primary"
                @click="addToList(field.list, field.listFields)"
            >
                <i class="fa fa-plus mr-2"></i>
                Add to list
            </a>
        </div>
        <div v-else="">
            {{ field.value }}
        </div>
    </div>
</template>

<script>
import MultiField from "./MultiField";
export default {
    name: "ListField",
    props: ["field", "edit", "patientData", "patientId"],
    components: { MultiField },
    created() {
        this.field.list = this.patientData[this.field.name];
    },
    methods: {
        addToList(list, fields) {
            let listItem = {};
            fields.forEach(f => {
                listItem[f.name] = f.value;
            });
            this.$emit("list-add", listItem);
            fields.forEach(f => {
                f.value = null;
            });
        },
    },
};
</script>
<style scoped lang="scss">
.list-props:not(:last-child):after {
    content: ", ";
}
.list-props:last-child:after {
    content: ".";
}
</style>
